(() => {
  'use strict';

  if (customElements.get('ct-shipping-countdown')) return;

  const storageKey = 'ct-shipping-countdown-deadline-v1';
  const duration = 15 * 60 * 1000;
  let memoryDeadline = null;

  function getDeadline() {
    try {
      const stored = Number(localStorage.getItem(storageKey));

      if (Number.isFinite(stored) && stored > 0) {
        memoryDeadline = stored;
        return stored;
      }
    } catch (_) {
      // Depolama kapalıysa mevcut sayfa boyunca belleği kullan.
    }

    if (!memoryDeadline) {
      memoryDeadline = Date.now() + duration;
    }

    try {
      localStorage.setItem(storageKey, String(memoryDeadline));
    } catch (_) {}

    return memoryDeadline;
  }

  customElements.define(
    'ct-shipping-countdown',
    class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;

        // Süreyi yalnızca sepet alanı görünür olduğunda başlat.
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.observer.disconnect();
          this.start();
        });

        // hidden olan sayacı değil, subtotal ile aynı kapsayıcıyı izle.
        this.observer.observe(this.parentElement);
      }

      start() {
        if (this.interval) return;

        this.deadline = getDeadline();
        this.timerNode = this.querySelector(
          '.ct-shipping-countdown__time'
        );

        if (!this.timerNode) return;

        const tick = () => {
          const seconds = Math.max(
            0,
            Math.ceil((this.deadline - Date.now()) / 1000)
          );

          if (seconds === 0) {
            this.hidden = true;
            clearInterval(this.interval);
            this.interval = null;
            return;
          }

          const minutes = Math.floor(seconds / 60);
          const remainder = seconds % 60;

          this.timerNode.textContent =
            String(minutes).padStart(2, '0') +
            ':' +
            String(remainder).padStart(2, '0');

          this.hidden = false;
        };

        this.interval = setInterval(tick, 1000);
        tick();

        this.onStorage = (event) => {
          if (event.key !== storageKey || !event.newValue) return;

          const deadline = Number(event.newValue);
          if (Number.isFinite(deadline) && deadline > 0) {
            this.deadline = deadline;
            tick();
          }
        };

        window.addEventListener('storage', this.onStorage);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;

        clearInterval(this.interval);
        this.interval = null;

        if (this.onStorage) {
          window.removeEventListener('storage', this.onStorage);
        }
      }
    }
  );
})();